<template>
  <div class="auth-page fill-height">
    <v-row class="align-center fill-height">
      <v-col :xs="12" :sm="12" :md="6" :lg="6">
        <router-view />
      </v-col>
      <v-col :xs="12" :sm="12" :md="6" :lg="6">
        <v-img src="/img/illustration-1.png" lazy-src="/img/illustration-1-min.png" height="628" />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: "AuthPage"
};
</script>
<style lang="scss">
.auth-page.fill-height {
  overflow: hidden;
}
</style>
